<template>
  <div class="measureSidebar">
    <div class="measureSidebar-panel">
      <neb-panel title="Quick Insights">
        <div class="measureSidebar-quickInsightList">
          <neb-pill-select :options="quickInsightPills"
            :value="selectedQuickInsight"
            @input="onQuickInsightInput"
          />
        </div>
      </neb-panel>
    </div>
    <div class="measureSidebar-panel">
      <neb-panel title="Collections">
        <div class="measureSidebar-panel-tree">
          <neb-tree :nodes="collectionOptions"
            maxHeight="250px"
            selectable
            singleSelect
            :loading="collectionsLoading"
            :selected="selectedCollection"
            @select="onCollectionSelect"
          ></neb-tree>
        </div>
      </neb-panel>
    </div>

    <div class="measureSidebar-panel">
      <neb-panel title="Saved Searches">
        <div class="measureSidebar-panel-tree">
          <neb-tree :nodes="savedSearchOptions"
            maxHeight="250px"
            selectable
            singleSelect
            :loading="savedSearchesLoading"
            :selected="selectedSavedSearch"
            @select="onSavedSearchSelect"
          ></neb-tree>
        </div>
      </neb-panel>
    </div>
  </div>
</template>

<script>
const quickInsightsColors = [
  '#bc8bed',
  '#4999f9',
  '#12d5ba',
  '#f489d3',
  '#f77f6c',
  '#7ed865'
]

export default {
  name: 'MeasureSidebar',

  props: {
    collectionOptions: {
      type: Array,
      default: () => []
    },
    selectedCollection: {
      type: String,
      default: ''
    },
    collectionsLoading: {
      type: Boolean,
      default: false
    },
    savedSearchOptions: {
      type: Array,
      default: () => []
    },
    savedSearchesLoading: {
      type: Boolean,
      default: false
    },
    selectedSavedSearch: {
      type: String,
      default: ''
    },
    quickInsightOptions: {
      type: Array,
      default: () => []
    },
    selectedQuickInsight: {
      type: String,
      default: null
    }
  },

  computed: {
    quickInsightPills () {
      return this.quickInsightOptions
        .map((p, idx) => ({ label: p.name, color: quickInsightsColors[idx], value: String(p.pk) }))
    }
  },

  methods: {
    onCollectionSelect (value) {
      this.$emit('change', { key: 'collection', value })
    },
    onSavedSearchSelect (value) {
      this.$emit('saved-search-select', value)
    },
    onQuickInsightInput (value) {
      this.$emit('quick-insight-select', value)
    }
  }
}
</script>

<style lang="scss">
@import '../Nebula/style.scss';

.measureSidebar {
  &-panel {
    &:not(:last-child) {
      margin-bottom: 15px;
    }

    .nebIcon {
      color: $warm-grey;
      cursor: pointer;

      &.active {
        color: $tiffany-blue;
      }
    }

    &-sort {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .nebIcon {
        &:not(:last-child) {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
